import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlag } from 'src/app/models/user';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private flags = new BehaviorSubject<FeatureFlag[]>([]);
  flags$ = this.flags.asObservable();

  setFlags(featureFlags: FeatureFlag[]) {
    this.flags.next(featureFlags);
  }

  hasFlag(flag: string): Observable<boolean> {
    return this.flags$.pipe(
      map((flgs) => flgs.some((f) => f.slug === flag && f.enabled))
    );
  }
  
  flagEnabled(flag: string): boolean {
    return this.flags.value.some((f) => f.slug === flag && f.enabled);
  }
}
